import { render, staticRenderFns } from "./ButtonAudio.vue?vue&type=template&id=85cb8042&scoped=true&"
import script from "./ButtonAudio.vue?vue&type=script&lang=js&"
export * from "./ButtonAudio.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAudio.vue?vue&type=style&index=0&id=85cb8042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cb8042",
  null
  
)

export default component.exports